module.exports = __webpack_public_path__ + "static/img/s-hw-3.b9a8e97.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/clac/img/s-hw-3.png
// module id = 6H95
// module chunks = 1